export const AUTO_REFRESH_DAILY = 'daily';
export const AUTO_REFRESH_WEEKLY = 'weekly';
export const AUTO_REFRESH_MONTHLY = 'monthly';
export const AUTO_REFRESH_NEVER = 'never';
